import { Flex, Icon, Stack, SystemProps } from "@storyofams/react-ui";
import { ReactNode } from "hoist-non-react-statics/node_modules/@types/react";

import { RichText, Text } from "../..";
import { ProductdetailItem } from "../../../lib/storyblok/sdk";
import { Checkmark } from "../../common/Icons";

interface SellingPointsProps extends SystemProps {
  items: ProductdetailItem["content"]["usps"];
}

export const SellingPoints = ({ items, ...props }: SellingPointsProps) => (
  <Stack {...props} color="#1D1D1BCC" space={"4px"} flexDirection="column">
    {items?.map(({ text, _uid }, i) => (
      <Flex key={_uid} alignItems="center">
        <Icon
          fontSize={["12px", "16px"]}
          lineHeight={["16.8px", "22.4px"]}
          icon={Checkmark}
          mr={["4px", 1]}
          opacity={"0.7"}
        />

        <RichText
          fontSize={["12px", "16px"]}
          lineHeight={["16.8px", "22.4px"]}
          text={text}
        />
      </Flex>
    ))}
  </Stack>
);

interface IconsSellingPointsProps {
  items: { icon: ReactNode; text: string }[];
}

export const IconsSellingPoints = ({
  items,
  ...props
}: IconsSellingPointsProps & SystemProps) => (
  <Stack space={2} width="100%" justifyContent="flex-start" {...(props as any)}>
    {items.map(({ icon, text }, i) => (
      <Flex key={text} flexDirection="column" alignItems="center">
        <Icon icon={icon} fontSize={5} mb={2} />

        <Text
          maxWidth="136px"
          textAlign="center"
          fontSize={[1.5, 1.75]}
          fontWeight="medium"
        >
          {text}
        </Text>
      </Flex>
    ))}
  </Stack>
);
